import ManageJobApplication from '../../../views/Personnel/Letter/ManageJobApplication.letter.view';

export default ManageJobApplication;
